<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="活动标题">
            <a-input :read-only="params.isShow" placeholder="请输入活动标题" v-decorator="[
              'title',
              {initialValue:data.title,rules: [{ required: true, message: '请输入活动标题' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型">
            <a-select :disabled="this.params.isShow" :options="this.promotionActivityTypeOptions" placeholder="请选择类型" v-decorator="[
              'activityType',
              {initialValue:data.activityType,rules: [{ required: true, message: '请选择类型' }]}]">
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效期">
            <a-range-picker :disabled="this.params.isShow" :disabledDate="disabledDate" v-decorator="[
              'rangeTime',
              {initialValue:data.rangeTime,rules: [{ required: true, message: '请选择有效期' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
    <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
      <a-form-item label>
        <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
        <a-button style="margin-left:10px" @click="cancel">取消</a-button>
      </a-form-item>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { constants } from "zlib";
import { fail } from "assert";
const defaultData = {
  id: 0,
  title: "",
  activityType: undefined,
  startTime: null,
  rangeTime: null,
  endTime: null
};
export default {
  name: "hp-manager-page-PromotionActivity-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      promotionActivityTypeOptions: []
    };
  },
  async mounted() {
    this.GetPromotionActivityTypeOptions();
    if (this.params.id) {
      this.getdetailPromotionActivity();
    } else {
      this.data = exzends(defaultData);
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    async GetPromotionActivityTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 5 });
      if (dictionary) {
        this.promotionActivityTypeOptions = [];
        dictionary.forEach(a => {
          this.promotionActivityTypeOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    async getdetailPromotionActivity() {
      this.loading = true;
      let result = await api.GetPromotionActivity({
        id: this.params.id
      });

      if (result) {
        this.data = result;
        this.data.rangeTime = [
          new moment(this.data.startTime),
          new moment(this.data.endTime)
        ];
      }

      this.data.activityType += "";
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        title: value.title,
        activityType: value.activityType,
        startTime: value.rangeTime[0].startOf("day").valueOf(),
        endTime: value.rangeTime[1].startOf("day").valueOf()
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);

        if (this.params.id > 0) {
          data = await api.CreateOrUpdatePromotionActivity(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.CreateOrUpdatePromotionActivity(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>
<style scoped>
.hp-editor {
  line-height: normal !important;
}
</style>


// WEBPACK FOOTER //
// src/router/Promotions/Activity/Add.vue